import React from "react";
import CategorySmallCards2 from "../Cards/CategorySmallCards2";

const Shopfromcategory = () => {
  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold md:ml-10 ml-2 mt-4 mb-4 ">
        Shop From Top Categories{" "}
      </h1>

        <div className='grid grid-cols-2 md:grid-cols-4 gap-3 md:px-12 lg:px-20 px-6 py-10'>
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>        
                 <CategorySmallCards2/>                           
        </div>
    </div>
  );
};

export default Shopfromcategory;
